export const getIntervals = (state) => state.intervals
